export default __webpack_public_path__ + "static/media/sarchs.8b3c543a.svg";